<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body text-center">
    <div class="form">
        <div class="body">
            <section class="container-custom flex">
                <article class="flex_content" *ngFor="let plan of plans; let i = index">
                    <h2>{{ plan.Value }}</h2>
                    <h4>{{ plan.pay_plan_price | currency:'PHP':'symbol' }} / Month (Vat Excluded)</h4>

                    <small class="text-muted d-block m-2">
                        * Monthly cost is based on the selected subscription plan. Payment will be processed securely
                        via Xendit.
                    </small>

                    <ul>
                        <li>Maximum of {{plan.maxEmployes}} Employees (excluding HR Administrator)</li>
                    </ul>

                    <button class="btn btn-success" type="submit"
                        (click)="renewPlan(plan.pay_plan_ID)"
                        *ngIf="!isLoading; else loadingTemplate">
                        Select
                    </button>

                    <ng-template #loadingTemplate>
                        <button class="btn btn-success" type="submit">
                            Select <span class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>
                    </ng-template>
                </article>
            </section>
        </div>
    </div>
</div>